// src/App.js
import "./App.css";
import Home from "./components/pages/Home";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/pages/Layout";
import ContactUs from "./components/pages/ContactUs";
import FAQs from "./components/pages/FAQs";
import TermsAndConditions from "./components/pages/TermsAndConditions";
import PrivacyPolicy from "./components/pages/PrivacyPolicy";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import ForgotPassword from "./components/pages/FogotPassword";
import NotFound from "./components/pages/NotFound";
import Dashboard from "./components/dashboard/Dashboard";
import UserProfile from "./components/dashboard/Profile";
import NoteComponent from "./components/dashboard/notes/Note";
import FileManager from "./components/dashboard/files/File";
import PortfolioManager from "./components/dashboard/portfolio/Portfolio";
import ProjectManager from "./components/dashboard/projects/Project";
import DailyChore from "./components/dashboard/dailyChores/DailyChore";
import SplitwiseApp from "./components/dashboard/splitwise/SplitwiseApp";
import CalendarEvents from "./components/dashboard/calendarEvents/CalendarEvents";
import Todos from "./components/dashboard/todos/Todos";
import OrgTreeMap from "./components/dashboard/orgTree/OrgTreeMap";
import ScreenListen from "./components/dashboard/screenListen/ScreenListen";
import MediaAnalyze from "./components/dashboard/mediaAnalyze/MediaAnalyze";
import VoiceAnalyse from "./components/dashboard/voiceAnalyse/VoiceAnalyse";
import VideoAi from "./components/dashboard/videoAi/VideoAi";
import TransferAi from "./components/dashboard/transferAi/TransferAi";
import ExamAi from "./components/dashboard/examAi/ExamAi";
import DayLifeAi from "./components/dashboard/dayLife/DayLifeAi";
import CollaborationJoin from "./components/pages/CollaborationJoin";
import Pricing from "./components/pages/Pricing";
import BlogIndex from "./components/pages/resources/BlogIndex";
import BlogPost from "./components/pages/resources/BlogPost";
import TemplatesIndex from "./components/pages/resources/TemplatesIndex";
import SuccessStoriesIndex from "./components/pages/resources/SuccessStoriesIndex";

const App = () => {
  const location = useLocation();

  // List of routes where the layout should not be rendered
  const noLayoutRoutes = [
    "/dashboard",
    "/dashboard/profile",
    "/dashboard/notes",
    "/dashboard/calendar-events",
    "/dashboard/files",
    "/dashboard/portfolio",
    "/dashboard/project",
    "/dashboard/daily-chore",
    "/dashboard/splitwise",
    "/dashboard/todos",
    "/dashboard/org-tree",
    "/dashboard/screen-listen",
    "/dashboard/media-analyze",
    "/dashboard/voice-analyse",
    "/dashboard/video-ai",
    "/dashboard/transfer-ai",
    "/dashboard/exam-ai",
    "/dashboard/day-life",
  ];

  // Check if the current path matches any in the noLayoutRoutes list
  const isNoLayoutRoute = noLayoutRoutes.includes(location.pathname);

  return (
    <>
      {/* Conditionally render Layout based on current path */}
      {isNoLayoutRoute ? (
        <Routes>
          <Route path="/dashboard" element={<Dashboard></Dashboard>}>
            <Route path="/dashboard/profile" element={<UserProfile />} />
            <Route path="/dashboard/notes" element={<NoteComponent />} />
            <Route path="/dashboard/calendar-events" element={<CalendarEvents />} />
            <Route path="/dashboard/files" element={<FileManager />} />
            <Route path="/dashboard/portfolio" element={<PortfolioManager />} />
            <Route path="/dashboard/project" element={<ProjectManager />} />
            <Route path="/dashboard/daily-chore" element={<DailyChore />} />
            <Route path="/dashboard/splitwise" element={<SplitwiseApp />} />
            <Route path="/dashboard/todos" element={<Todos />} />
            <Route path="/dashboard/org-tree" element={<OrgTreeMap />} />
            <Route path="/dashboard/screen-listen" element={<ScreenListen />} />
            <Route path="/dashboard/media-analyze" element={<MediaAnalyze />} />
            <Route path="/dashboard/voice-analyse" element={<VoiceAnalyse />} />
            <Route path="/dashboard/video-ai" element={<VideoAi />} />
            <Route path="/dashboard/transfer-ai" element={<TransferAi />} />
            <Route path="/dashboard/exam-ai" element={<ExamAi />} />
            <Route path="/dashboard/day-life" element={<DayLifeAi />} />
          </Route>
        </Routes>
      ) : (
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/templates" element={<TemplatesIndex />} />
            <Route path="/success-stories" element={<SuccessStoriesIndex />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/collaboration/join" element={<CollaborationJoin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      )}
    </>
  );
};

export default App;
